module.exports = __webpack_public_path__ + "img/about-4-INTname.aeef0e25.png";